import { useEffect, useState } from "react";
import { authManager } from "../../data/managers/AuthManager";
import { useAuth } from "../../data/providers/AuthProvider";

export function useLogin() {
  useEffect(() => {
    document.title = "LyPro AI - Login";
  }, []);

  const { user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isEmailValid = emailRegex.test(email);
  const isPasswordValid = password.length >= 6;
  const isFormValid = isEmailValid && isPasswordValid;
  const backgroundImage = "/assets/background.jpg";

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!isFormValid) return;

    setIsSubmitting(true);
    setError("");

    try {
      const isLogged = await authManager.login(email, password);
      if (!isLogged) {
        setError("Correo o contraseña incorrectos");
      }
    } catch (error: any) {
      setError(error ?? "Correo o contraseña incorrectos");
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    user,
    email,
    password,
    error,
    isSubmitting,
    backgroundImage,
    isEmailValid,
    isPasswordValid,
    isFormValid,
    setEmail,
    setPassword,
    setError,
    setIsSubmitting,
    handleLogin,
  };
}
